module.exports = __webpack_public_path__ + "media/direct_cabinet_n4.1273ce1d.wav";